<script setup lang="ts"></script>

<template lang="pug">
.container().mx-auto.px-2
  slot
</template>
